<template>
    <table>
        <thead>
            <tr>
                <th colspan="4">{{ title }}</th>
            </tr>
            <tr v-if="brandZones.length">
                <th colspan="4" class="selectors pl-0">
                    <div class="row">
                        <div class="col-auto">
                            <ClientColorButton :size="'s'" :inactive-color="true" @click="selectAll()">{{
                                $t("common.selectAll")
                            }}</ClientColorButton>
                        </div>
                        <div class="col-auto">
                            <ClientColorButton :size="'s'" :inactive-color="true" @click="selectNone()">{{
                                $t("common.selectNone")
                            }}</ClientColorButton>
                        </div>
                        <!-- <div class="col-auto"> -->
                        <!--
                        <ClientColorButton :size="'s'" :inactive-color="true" @click="resetSelectedProfiles()">{{ $t('common.resetSelection') }}</ClientColorButton>
                    -->
                        <!-- </div> -->
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="brandZone in brandZones" :key="brandZone.zone.id">
                <td>
                    <label
                        :for="'checkbox_zone_' + brandZone.zone.id"
                        class="label-checkbox pointer mb-0 d-flex align-items-center justify-content-center"
                    >
                        <span
                            v-show="checkedZones.includes(brandZone.zone.id)"
                            @click="checkZone(brandZone.zone.id, false)"
                            class="rem3rch-checkbox rem3rch-checkbox"
                        >
                            <i class="fa fa-check"></i>
                        </span>
                        <span
                            v-if="!checkedZones.includes(brandZone.zone.id)"
                            @click="checkZone(brandZone.zone.id, true)"
                            class="rem3rch-checkbox rem3rch-checkbox"
                        ></span>
                    </label>
                </td>
                <td class="id">{{ brandZone.zone.id }}</td>
                <td class="refClient">{{ brandZone.zone.refClient }}</td>
                <td class="name">{{ brandZone.zone.name }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import loader from "@/components/loader/loader";

export default {
    components: {
        loader
    },
    props: {
        title: {
            type: String,
            required: true
        },
        brandZones: {
            type: Array,
            required: true
        },
        checkedZones: {
            type: Array,
            required: true
        }
    },
    data: () => ({}),
    computed: {},
    methods: {
        selectAll() {
            this.brandZones.forEach(bz => {
                if (!this.checkedZones.includes(bz.zone.id)) {
                    this.checkedZones.push(bz.zone.id);
                }
            });
        },
        selectNone() {
            this.checkedZones = [];
        },
        checkZone(zoneId, add) {
            if (add) {
                this.checkedZones.push(zoneId);
            } else {
                this.checkedZones.splice(this.checkedZones.indexOf(zoneId), 1);
            }
        }
    },
    created() {}
};
</script>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    table-layout: auto !important;
    width: 100%;
    overflow-x: scroll;
    overflow-wrap: break-word;
    th {
        &:not(.selectors) {
            font-family: "Oswald", sans-serif;
            font-size: 16px;
            background: #343434;
            color: #fff;
            text-transform: uppercase;
            text-align: center;
        }
        vertical-align: center;
        padding: 15px 10px;
        font-weight: normal;
        overflow-wrap: break-word;
    }
    td {
        transition: 0.3s ease-in-out;
        padding: 15px 10px;
        background-color: #f4f4f4;
        border-bottom: 5px solid #fff;
        &.id {
            color: #111;
            font-size: 16px;
        }
        &.refClient,
        &.name {
            color: #111;
            font-size: 16px;
            font-family: "Oswald", sans-serif;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ZoneGroupsTable.vue?603ffb1d